import { render } from "./index.vue?vue&type=template&id=548a2656&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=548a2656&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=548a2656&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548a2656"]])

export default __exports__